export enum CardImageType {
	Front,
	Back
}
